import React, { Component } from 'react'
import { connect } from 'react-redux'
import orderBy from 'lodash/orderBy'
import {
  pullAndSetMyReceipts,
  setFilters,
  selectMyReceiptsRowAndGetDetails,
} from './MyReceiptsActions'
import { Body, Drawer } from '../Shell/Shell'
import { PageError } from '../PageError/PageError'
import Table from '../Table/Table'
import TableControls from 'components/Table/TableControls'
import EmptyBox from '../MyRecords/EmptyBox'
import ReportDownload from './ReportDownload'
import NotFound from '../NotFound/NotFound'
import MyReceiptDetails from './MyReceiptDetails'
import _ from 'lodash'

class MyReceipts extends Component {
  componentDidMount() {
    this.getRecords()
  }

  getRecords = () => {
    this.props.pullAndSetMyReceipts(this.props.match.params.subParam)
  }

  debounced = _.debounce(() => {
    this.getRecords()
  }, 700)

  setFilters = (filters, props = {}) => {
    this.props.setFilters('myReceipts', filters)
    this.debounced()
  }

  selectRow = (row) => {
    if (this.props.selectedId === row.RECEIPT_ID) {
      return
    } else if (this.props.selectedId) {
      this.clearSelection()
    } else {
      this.props.selectMyReceiptsRowAndGetDetails(
        this.props.selectedId === row.RECEIPT_ID ? null : row.RECEIPT_ID,
        row
      )
    }
  }

  clearSelection = () => {
    this.props.selectMyReceiptsRowAndGetDetails(null, null)
  }

  renderEmptyResults() {
    return (
      <div className="empty-placeholder-wrapper">
        <EmptyBox />
        <h3>No Receipts Found.</h3>
        <div className="flex-row center"></div>
      </div>
    )
  }

  renderPageData(props) {
    if (!_.isEmpty(props.rows)) {
      let rows = orderBy(
        Object.keys(props.rows).map((rowId) => props.rows[rowId]),
        'REF_NUM',
        'desc'
      )
      rows.forEach((row, index) => {
        if (Number.isInteger(row.AMOUNT)) {
          row.AMOUNT = parseInt(row.AMOUNT, 10).toFixed(2)
        }
      })

      return (
        <Table
          rows={rows}
          template={props.template}
          className="center-container"
          onCellClick={this.selectRow}
          selectedRowIndex={
            rows ? rows.findIndex((row) => row.RECEIPT_ID === this.props.selectedId) : false
          }
          animated={false}
          rowCount
        />
      )
    } else if (!props.loading) {
      if (props.error) {
        return <PageError errorDetails={props.errorDetails} />
      }

      return this.renderEmptyResults()
    }
  }

  render() {
    const { selectedId, selectedReceipt, showSelected, filters, loading } = this.props

    const activeFilter = filters.myReceipts || {
      SEARCH: '',
      DATE_RANGE: { start: null, end: null },
      REF_NUM: '',
      RECEIPT_NUM: '',
      DESCRIPTION: '',
      AMOUNT: '',
      TYPE: '',
    }

    const filterTemplate = process.env.MY_RECEIPTS_FILTER
    const showHelpText = process.env.SHOW_MY_RECEIPTS_HELPER_TEXT
    const helpLabel = process.env.MY_RECEIPTS_HELPER_LABEL
    const helpText = process.env.MY_RECEIPTS_HELPER_TEXT

    return (
      <Body
        className="my-records"
        showDrawer={showSelected}
        onResize={this.onBodyResize}
        hiddenTitle="My Records"
      >
        {process.env.MY_RECEIPTS_SHOW_IN_SIDEBAR ? (
          <div>
            <TableControls
              title={`My Receipts`}
              filterTemplates={filterTemplate}
              filters={activeFilter}
              allowSearch={true}
              onFilterChange={this.setFilters}
              loading={loading}
              showHelpText={showHelpText ? true : false}
              helpLabel={helpLabel ? helpLabel : ''}
              helpText={helpText ? helpText : ''}
            />
            {this.renderPageData(this.props)}
            <Drawer
              title="Receipt Details"
              showCloseButton
              show={selectedId ? true : false}
              onSidebarDismiss={this.clearSelection}
            >
              <ReportDownload
                id={selectedId}
                formDefinitionId={selectedReceipt ? selectedReceipt.FORM_DEFINITION_ID : -1}
                selectedReceipt={selectedReceipt}
              />
              <MyReceiptDetails selectedReceipt={selectedReceipt} />
            </Drawer>
          </div>
        ) : (
          <NotFound />
        )}
      </Body>
    )
  }
}

MyReceipts = connect(
  (state, props) => ({
    rows: state.myReceipts.rows,
    template: state.myReceipts.template,
    loading: state.myReceipts.loading,
    selectedId: state.myReceipts.selected[props.match.params.subParam],
    showSelected: state.myReceipts.showSelected,
    selectedReceipt: state.myReceipts.selectedReceipt,
    filters: state.myReceipts.filters,
    error: state.myReceipts.error,
    errorDetails: state.myReceipts.errorDetails,
    awaitFilter: 800,
  }),
  {
    pullAndSetMyReceipts,
    setFilters,
    selectMyReceiptsRowAndGetDetails,
  }
)(MyReceipts)

export default MyReceipts



// WEBPACK FOOTER //
// ./src/components/MyReceipts/MyReceipts.js